module.exports = __webpack_public_path__ + "static/img/vip-nav-normal.853c804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vip-nav-normal.png
// module id = DSm0
// module chunks = 16